import { call, put, takeLatest } from "redux-saga/effects";
import {
  getClassPeriodsRequest,
  getClassPeriodsSuccess,
} from "./classPeriodsSlice"; 
import { GetAllClassPeriodsMapping } from "../../api/ClassPeriods/ClassPeriodsService";

function* fetchClassPeriodsSaga(action) {
  try {
    const {schoolID} = action.payload;
    const response = yield call(GetAllClassPeriodsMapping, schoolID);
    yield put(getClassPeriodsSuccess(response?.data)); 
  } catch (error) {
    yield put(getClassPeriodsSuccess([])); 
    // yield put(getClassPeriodsFailure(error.message || "Something went wrong"));
  }
}

export default function* watchClassPeriods() {
  yield takeLatest(getClassPeriodsRequest.type, fetchClassPeriodsSaga);
}

